import { Fragment } from "react";
import { Button } from "reactstrap";

const RetryQuery = ({msg, execute, values, logquery}) => {
  const retryQuery = async () => {
    values.forceQuery = true;
    await execute(values);
  }

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <i className="far fa-times-circle text-warning" style={{fontSize:58}}></i>
        <span className="mt-2" style={{fontSize:20}}>
          {msg}
        </span>
      </div>
      <div className="mt-3 d-flex flex-column">
        <b className="text-danger">ATENÇÃO!!!</b>
        <b className="text-danger">Ao “Reenviar Consulta” haverá tarifação normalmente.</b>
        <div className="mt-2 d-flex align-items-end justify-content-between">
          <Button color="primary" onClick={() => {retryQuery()}}>
            <i className="fas fa-sync-alt mr-2"></i>
            Reenviar Consulta
          </Button>
          <Button color="info" onClick={() => {window.open(`/historico/${logquery}`,`${Date.now()}`)}}>
            <i className="fas fa-clock-rotate-left mr-2"></i>
            Histórico de Consultas
          </Button>
        </div>
      </div>
    </Fragment>
  );
}

export default RetryQuery;

